import { useApi, useToaster } from "@shopexperts/shared";
import { useMutation, useQueryClient } from "@tanstack/vue-query";
import type { CreatePageSchemaRequest } from "@shopexperts/shared";

export function useCreateSchema() {
  const api = useApi();
  const queryClient = useQueryClient();
  const toaster = useToaster();

  return useMutation({
    mutationFn: (data: CreatePageSchemaRequest) => 
      api.admin.pages.createSchema({ body: data }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'page-schemas'] });
      toaster.create({
        title: "Schema created successfully",
        type: "success",
      });
    },
    onError: (error: any) => {
      console.error('[useCreateSchema] Error:', error);
      
      const errorMessage = 
        error?.response?.data?.message || 
        error?.response?.data?.error ||
        error?.message ||
        'An error occurred while creating the schema.';
      
      toaster.create({
        title: "Failed to create schema",
        description: errorMessage,
        type: "error",
      });
    },
  });
}

